import React from 'react';
import { HorizontalMenuModel } from 'types/model';
import { HorizontalMenu } from './menu';
import { DeviceType } from 'types';

type HorizontalMenuSetupProps = {
  disableHorizontalMenu?: boolean;
  model: HorizontalMenuModel;
  deviceType: DeviceType;
};

export const HorizontalMenuSetup = ({
  disableHorizontalMenu,
  model,
  deviceType,
}: HorizontalMenuSetupProps) => {
  const { list, enable } = model;

  if (disableHorizontalMenu || !enable || list.length === 0) {
    return null;
  }

  return <HorizontalMenu list={list} deviceType={deviceType} />;
};
